import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

import { AddOtherLoan } from "../components/AddOtherLoan";
import { OtherLoansReview } from "../components/OtherLoansReview";

export function createOtherLoansScreens(firstName: string): FlowScreenConfig[] {
  return [
    {
      id: "review_other_loans",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: OtherLoansReview,
      shouldDisplay: ({ answers }) => answers["review_other_loans"] !== "none",
    },
    {
      id: "other_loans",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: `Did ${firstName} have any other loans?`,
      subtitle: "This could be personal loans, car loans, or any type of loan not already listed.",
      question: {
        type: "multiple_choice",
        required: true,
        options: [
          { value: "yes", label: "Yes, they had loans" },
          { value: "no", label: "No other loans" },
          { value: "not_sure", label: "Not sure" },
        ],
      },
      shouldDisplay: ({ answers }) => answers["review_other_loans"] === "none",
    },
    {
      id: "add_other_loan",
      layout: "full",
      textAlign: "center",
      maxWidth: "4xl",
      title: "Add loan information",
      subtitle: "Add what you know. We'll help you gather details later.",
      hideButton: true,
      customComponent: AddOtherLoan,
      shouldDisplay: ({ answers }) =>
        (answers["review_other_loans"] === "none" &&
          answers["other_loans"] === "yes" &&
          answers["add_other_loan"] !== "done") ||
        answers["add_other_loan"] === "adding",
    },
  ];
}
